import LXCenter from '../core/components/center';
import ResetForm from './components/resetForm';
const ResetPage: React.FC = () => {
  return (
    <LXCenter>
      <ResetForm></ResetForm>
    </LXCenter>
  );
};

export default ResetPage;
